import { render, staticRenderFns } from "./SchoolLogs.vue?vue&type=template&id=7a14d9bb&"
import script from "./SchoolLogs.ts?vue&type=script&lang=ts&"
export * from "./SchoolLogs.ts?vue&type=script&lang=ts&"
import style0 from "./SchoolLogs.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports